import { Box, Stack } from '@mantine/core'
import { TGatewayListItem, TLoraDevice, TSnmpDevice } from 'shared/types'
import { CodeBox } from '../..'

type OmitToken<T> = Omit<T, 'deviceToken'>

export const DeviceKeys = ({
  keys,
}: {
  keys:
    | OmitToken<TLoraDevice>
    | OmitToken<TGatewayListItem>
    | OmitToken<TSnmpDevice>
}) => {
  const keysEntries = Object.entries(keys).filter(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_key, value]) => typeof value === 'number' || typeof value === 'string',
  ) as [string, string | number][]

  return (
    <Box>
      <Stack gap={'xs'}>
        {keysEntries.map(([key, value]) => (
          <CodeBox
            key={key}
            label={key.toUpperCase()}
            value={value.toString()}
            withHideButton={key.toLowerCase().includes('key')}
          />
        ))}
      </Stack>
    </Box>
  )
}
